/**
 * The mascot at the two scales a blank screen wants him.
 *
 * `page` is the whole figure, for a route that has nothing on it at all - a
 * 404, a crash. `compact` is just his face, for a panel inside a page that is
 * otherwise full: a bet slip, a notification tray, a filtered game grid.
 */
export const EMPTY_MASCOT_SRC = "/assets/images/mascot-hero.webp";
export const EMPTY_MASCOT_AVATAR_SRC = "/assets/images/mascot-head.webp";

export const EMPTY_SIZES = {
  compact: 96,
  page: 220,
} as const;

export const EMPTY_MIN_HEIGHT = {
  compact: 220,
  page: 360,
} as const;
